import { AdminConvertGuestUserPage } from "./pages/Admin/AdminConvertGuestUserPage.js";
import { AdminCreateUserPage } from "./pages/Admin/AdminCreateUserPage.js";
import { AdminPage } from "./pages/Admin/AdminPage.js";
import { BulkUserConfigurationPage } from "./pages/Admin/BulkUserConfigurationPage.js";
import { GenericInstanceCreateEdit } from "./pages/Admin/GenericInstanceCreateEdit.js";
import { OrganisationCreateEdit } from "./pages/Admin/OrganisationCreateEdit.js";
import { RioInstanceCreateEdit } from "./pages/Admin/RioInstanceCreateEdit.js";
import { SupersetDashboardCreateEdit } from "./pages/Admin/SupersetDashboardCreateEdit.js";
import { TeamCreateEditPage } from "./pages/Admin/TeamCreateEditPage.js";
import { TermsAndConditionsCreateEditPage } from "./pages/Admin/TermsAndConditionsCreateEditPage.js";
import { TppInstanceCreateEdit } from "./pages/Admin/TppInstanceCreateEdit.js";
import { UserDeviceSessionsPage } from "./pages/Admin/UserDeviceSessionsPage.js";
import { UserMembershipsPage } from "./pages/Admin/UserMembershipsPage.js";
import { UserOrganisationConfigurationPage } from "./pages/Admin/UserOrganisationConfigurationPage.js";
import { CareHomeRegisterPage } from "./pages/CareHomeRegister/CareHomeRegisterPage.js";
import { ResidentPage } from "./pages/CareHomeRegister/ResidentPage.js";
import { CaseloadPage } from "./pages/Caseload/Caseload.js";
import { DashboardHomePage } from "./pages/dashboard/DashboardHomePage.js";
import { DataGlossaryPage } from "./pages/DataGlossaryPage/DataGlossaryPage.js";
import { DeliberatelyThrowsAnErrorPage } from "./pages/DeliberatelyThrowsAnErrorPage.js";
import { DemographicsManagerHomePage } from "./pages/DemographicsManagerPage/DemographicsManagerPage.js";
import { EditMhaStatusPage } from "./pages/EditMhaStatus/EditMhaStatusPage.js";
import { EMHFormsShareCodePage } from "./pages/eMhFormsShareCodePage.js";
import ErrorPage from "./pages/ErrorPage.js";
import { TeamsOverviewPage } from "./pages/ExternalAdmin/Teams/TeamsOverviewPage.js";
import { UserOverviewPage } from "./pages/ExternalAdmin/Users/UserOverviewPage.js";
import { FavouriteRecipientsPage } from "./pages/FavouriteRecipientsPage/index.js";
import { FormDraftCompletionPage } from "./pages/FormDraft/FormDraftCompletionPage.js";
import { FormDraftSignPage } from "./pages/FormDraft/FormDraftSignPage.js";
import { FormContextPage } from "./pages/FormProgressPage/FormContextPage.js";
import { FormReviewPage } from "./pages/FormReviewPage.js";
import FormUpload from "./pages/FormUpload/FormUpload.js";
import { GuestUserLoginPage } from "./pages/GuestUserLoginPage.js";
import { HomePage } from "./pages/HomePage.js";
import { InterviewInviteResponsePage } from "./pages/InterviewInviteResponsePage/index.js";
import { LoginPage } from "./pages/LoginPage.js";
import { NetworkMapWorkspace } from "./pages/NetworkMap/NetworkMapWorkspace.js";
import NewSoadAssessment from "./pages/NewSoadAssessment/NewSoadAssessment.js";
import { NHSDashboardPage } from "./pages/nhsDashboardPage/nhsDashboardPage.js";
import NotFound from "./pages/NotFound.js";
import { NotificationsPage } from "./pages/NotificationsPage.js";
import { OrganisationHomePage } from "./pages/OrganisationHomePage.js";
import { PathwayWorkspace } from "./pages/PathwayAnalytics/PathwayWorkspace.js";
import { PatientHomePage } from "./pages/PatientHomePage.js";
import { PatientContextLaunchPage } from "./pages/PatientIndex/PatientContextLaunchPage.js";
import { PatientEditPage } from "./pages/PatientIndex/PatientEditPage.js";
import {
  PatientCreatePage,
  PatientPage,
} from "./pages/PatientIndex/PatientSearch.js";
import { PatientLinkToPdsPage } from "./pages/PatientLinkToPdsPage/PatientLinkToPdsPage.js";
import { PatientListPage } from "./pages/PatientList/PatientListPage.js";
import { PatientMergeConfirmation } from "./pages/PatientMergeV2/PatientMergeConfirmation.js";
import { PatientMergeSearch } from "./pages/PatientMergeV2/PatientMergeSearch.js";
import { PatientSearchReasoningPage } from "./pages/PatientSearchReasoning/PatientSearchReasoning.js";
import { RedoReviewPage } from "./pages/RedoReviewPage/RedoReviewPage.js";
import { MyPaymentRequestsPage } from "./pages/Section12PaymentRequests/MyPaymentRequestsPage.js";
import { PaymentReviewerPaymentRequestsPage } from "./pages/Section12PaymentRequests/PaymentReviewerPaymentRequestsPage.js";
import { CalendarCallbackPage } from "./pages/Section12Profile/CalendarCallbackPage.js";
import { SingleUseActionTokenPage } from "./pages/SingleUseActionTokenPage/SingleUseActionTokenPage.js";
import { SoadReportFormCompletion } from "./pages/SoadReportFormCompletion/SoadReportFormCompletion.js";
import { SoadSignAndSendPage } from "./pages/SoadSignAndSendPage/SoadSignAndSendPage.js";
import { SoadSubmitReviewPage } from "./pages/SoadSubmitReviewPage/SoadSubmitReviewPage.js";
import { SupersetDashboardPage } from "./pages/supersetDashboardPage/SupersetDashboardPage.js";
import { UserProfile } from "./pages/UserProfile/UserProfile.js";
import { VisionIncidentPreviewPage } from "./pages/VisionIncidentPreviewPage.js";
import { rawRoutesBase } from "./routePaths.js";
import { TeamEditPage } from "~/pages/ExternalAdmin/Teams/TeamEdit.js";
import { MhaStatusDashboardPage } from "~/pages/MhaStatusDashboard/MhaStatusDashboardPage.js";

// Binds page components to the component-free route definitions in routePaths.ts.
// This is the only module that imports the page-component graph; it is consumed
// only by App.tsx (to render the router).
const routeComponents = {
  home: HomePage,
  demographicsManagement: DemographicsManagerHomePage,
  testErrorPage: DeliberatelyThrowsAnErrorPage,
  errorPage: ErrorPage,
  visionPreviewIncident: VisionIncidentPreviewPage,
  dashboard: DashboardHomePage,
  // Bound to satisfy the route-key map; actually rendered via App.tsx's
  // early-return (chromeless, outside <Layout>), not this table.
  pathwayAnalytics: PathwayWorkspace,
  // Rendered via App.tsx's early-return (chromeless), not this table.
  networkMap: NetworkMapWorkspace,
  nhsDashboard: NHSDashboardPage,
  dashboardViewer: SupersetDashboardPage,
  dataGlossary: DataGlossaryPage,
  patientList: PatientListPage,
  caseloadUser: CaseloadPage,
  caseloadCaseload: CaseloadPage,
  caseloadArchive: CaseloadPage,
  notifications: NotificationsPage,
  teamCreateEdit: TeamCreateEditPage,
  managerTeamEdit: TeamEditPage,
  organisationHome: OrganisationHomePage,
  organisationCreateEdit: OrganisationCreateEdit,
  PatientSearchReasoningPage: PatientSearchReasoningPage,
  formUploadSelectedTemplate: FormContextPage,
  formUpload: FormUpload,
  patientMergeSearch: PatientMergeSearch,
  patientMergeConfirmation: PatientMergeConfirmation,
  patientLinkToPds: PatientLinkToPdsPage,
  patientSyncExternalLink: PatientHomePage,
  patientSearch: PatientPage,
  patientCreate: PatientCreatePage,
  patientCreateFromExternalId: PatientContextLaunchPage,
  patientHome: PatientHomePage,
  patientHomeActivityLog: PatientHomePage,
  patientHomeReconciliation: PatientHomePage,
  patientEdit: PatientEditPage,
  patientFormLaunch: PatientHomePage,
  SoadSignAndSendPage: SoadSignAndSendPage,
  soadSubmitReviewPage: SoadSubmitReviewPage,
  formContextPage: FormContextPage,
  formContextPageActivityLog: FormContextPage,
  formContextReasonForNotProceedingDialog: FormContextPage,
  formContextReopenAdmissionDialog: FormContextPage,
  formContextUnfinaliseDialog: FormContextPage,
  formContextPagePatientReconciliation: FormContextPage,
  formContextPageSendRequest: FormContextPage,
  formContextPageSuccessDialog: FormContextPage,
  formContextPageConfirmDeleteDraftDialog: FormContextPage,
  formContextPageRequestAmendDialog: FormContextPage,
  formContextPageRequestDeMinimisDialog: FormContextPage,
  formContextPageRequestRedoDialog: FormContextPage,
  formContextInterviews: FormContextPage,
  formContextFindDoctors: FormContextPage,
  formContextS12PaymentRequest: FormContextPage,
  formContextS12PaymentRequestReview: FormContextPage,
  formContextPageConfirmFinaliseDialog: FormContextPage,
  formContextPageEditMhaStatusDialog: FormContextPage,
  formPageLaunchLinkedForm: FormContextPage,
  formDraftsComplete: FormDraftCompletionPage,
  formDraftsSign: FormDraftSignPage,
  formReview: FormReviewPage,
  formRedoReview: RedoReviewPage,
  notFound: NotFound,
  calendarCallbackPage: CalendarCallbackPage,
  userProfilePage: UserProfile,
  userMembershipsPage: UserMembershipsPage,
  userDeviceSessionsPage: UserDeviceSessionsPage,
  userOrganisationConfigurationPage: UserOrganisationConfigurationPage,
  favouriteRecipientsPage: FavouriteRecipientsPage,
  interviewInviteResponsePage: InterviewInviteResponsePage,
  myPaymentRequestsPage: MyPaymentRequestsPage,
  paymentReviewerPage: PaymentReviewerPaymentRequestsPage,
  adminConverGuestUserPage: AdminConvertGuestUserPage,
  adminApprovedEmailDomains: AdminPage,
  adminEmailRedirects: AdminPage,
  adminTeamMerge: AdminPage,
  adminAuditTrailListsPage: AdminPage,
  adminAuditTrailCurrentUserPage: AdminPage,
  adminAuditTrailResourcePage: AdminPage,
  adminBulkUsersPage: BulkUserConfigurationPage,
  adminBulkCreateUsersPage: BulkUserConfigurationPage,
  managerUsersPage: UserOverviewPage,
  managerTeamsPage: TeamsOverviewPage,
  adminUsersPage: AdminPage,
  adminCreateUsersPage: AdminCreateUserPage,
  adminTeamsPage: AdminPage,
  adminOrganisationsPage: AdminPage,
  adminDataPermissionsPage: AdminPage,
  adminPatientDetailsPage: AdminPage,
  loginPage: LoginPage,
  careHomeRegister: CareHomeRegisterPage,
  residentPage: ResidentPage,
  mhaStatusDashboardPage: MhaStatusDashboardPage,
  emhFormsShareCodePage: EMHFormsShareCodePage,
  guestUserLogin: GuestUserLoginPage,
  patientEditDialog: FormDraftCompletionPage,
  formContextAddFileNoteDialog: FormContextPage,
  formContextDeleteFileNoteDialog: FormContextPage,
  formContextDeleteUploadedFormDialog: FormContextPage,
  patientEditDialogSuccess: FormDraftCompletionPage,
  adminRioInstancesPage: AdminPage,
  rioInstanceCreateEdit: RioInstanceCreateEdit,
  adminTppInstancesPage: AdminPage,
  tppInstanceCreateEdit: TppInstanceCreateEdit,
  adminGenericInstancesPage: AdminPage,
  genericInstanceCreateEdit: GenericInstanceCreateEdit,
  adminEprUserLinksPage: AdminPage,
  adminSupersetDashboardsPage: AdminPage,
  supersetDashboardCreateEdit: SupersetDashboardCreateEdit,
  useSingleUseActionToken: SingleUseActionTokenPage,
  singleUseActionTokensPage: AdminPage,
  adminSection12SpecialismsPage: AdminPage,
  adminSection12LanguagesPage: AdminPage,
  adminSection12PaymentRequestsPage: AdminPage,
  adminSection12DoctorsPage: AdminPage,
  adminIcbsPage: AdminPage,
  adminLocalAuthorityPaymentRatesPage: AdminPage,
  pdsConfiguration: AdminPage,
  rafConfiguration: AdminPage,
  s12ApprovalConfiguration: AdminPage,
  odsConfiguration: AdminPage,
  xeroConfiguration: AdminPage,
  dataSharingPartershipPage: AdminPage,
  placeOfSafetyManagementPage: AdminPage,
  adminTrustsPage: AdminPage,
  adminMentalHealthCareProvidersPage: AdminPage,
  termsAndConditionsManagementPage: AdminPage,
  termsAndConditionsCreateEdit: TermsAndConditionsCreateEditPage,
  editMhaStatusPage: EditMhaStatusPage,
  newSoadAssessment: NewSoadAssessment,
  soadReportFormDraftCompletionPage: SoadReportFormCompletion,
  londonCareRecordConfigurationPage: AdminPage,
  fhirApiClientsPage: AdminPage,
} satisfies Record<keyof typeof rawRoutesBase, unknown>;

export const routes = Object.entries(rawRoutesBase).map(([key, route]) => ({
  path: route.path,
  exact: route.exact,
  component: routeComponents[key as keyof typeof routeComponents],
  breadcrumb: route.breadcrumb,
}));
